@if (data?.isPopUp) {
  <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
    @if (data?.title) {
      <div fxLayout="row" fxLayoutAlign="space-between start" class="title-container">
        <div fxLayout="column" fxLayoutAlign="start start">
          @if (data?.subTitle) {
            <div class="sub-title">
              {{ data.subTitle }}
            </div>
          }
          <div class="popup-title">{{ data.title }}</div>
        </div>
        <div (click)="close()" class="close-btn">
          <mat-icon class="icon">close</mat-icon>
        </div>
      </div>
    }
    <div class="date-header" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="date-picker-container" fxLayout="row" fxLayoutAlign="start center">
        <div class="default-select" *ngIf="gardeNeedsTables && gardeNeedsTables.length > 6">
          <div class="select-container">
            <select
              [(ngModel)]="selectedNeedsTable"
              (ngModelChange)="onChangeSelectedNeedsTable($event)"
              [ngModelOptions]="{ standalone: true }"
            >
              <option *ngFor="let gardeNeedsTable of gardeNeedsTables" [ngValue]="gardeNeedsTable">
                {{ gardeNeedsTable.formationsGroup.displayName }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="tab" *ngIf="gardeNeedsTables && gardeNeedsTables.length <= 6">
      <div
        *ngFor="let gardeNeedsTable of gardeNeedsTables"
        class="tab"
        [class.selected]="
          selectedNeedsTable &&
          selectedNeedsTable.formationsGroup &&
          selectedNeedsTable.formationsGroup.displayName === gardeNeedsTable.formationsGroup.displayName
        "
        (click)="onChangeSelectedNeedsTable(gardeNeedsTable)"
      >
        {{ gardeNeedsTable.formationsGroup.displayName }}
      </div>
    </div>

    <div *ngIf="!isDataLoading">
      <ng-container *ngIf="selectedNeedsTable && (selectedNeedsTable.reasonMapsGarde?.length ?? 0) > 0">
        <div style="margin-bottom: 16px">
          <div class="popup-consultations-container2" fxLayout="column" fxLayoutAlign="start start">
            <table class="width-100">
              <thead>
                <tr>
                  <th class="tab-header-container">
                    <div class="tab-header">
                      <span class="code-rh-title">Codes RH</span>
                      <div class="diagonal-line"></div>
                      <span class="needs-title">Bilan</span>
                    </div>
                  </th>
                  <th *ngFor="let day of days; let i = index">
                    <p class="day-needs">
                      {{ dayEffectifs[i] }} / {{ dayNeeds[i] }}
                      <span
                        [class.green-text]="dayEffectifs[i] - dayNeeds[i] >= 0"
                        [class.red-text]="dayEffectifs[i] - dayNeeds[i] < 0"
                        >({{ (dayEffectifs[i] - dayNeeds[i] >= 0 ? '+' : '') + (dayEffectifs[i] - dayNeeds[i]) }})</span
                      >
                    </p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let reasonMapGarde of selectedNeedsTable.reasonMapsGarde; let index = index">
                  <td>
                    <div class="color-white">{{ reasonMapGarde.code }}</div>
                  </td>
                  <td *ngFor="let day of days; let i = index">
                    <ng-container
                      *ngIf="selectedNeedsTable.gardeNeeds[i] && selectedNeedsTable.gardeNeeds[i].needs.length > 0"
                    >
                      <div
                        fxLayout="row"
                        class="reasonMap-info-container"
                        [ngClass]="{ disabled: isDayDisabled(day, reasonMapGarde) }"
                      >
                        <div fxFlexAlign="center">
                          <span class="font-weight-700 font-size-14px color-white">
                            {{ selectedNeedsTable.gardeNeeds[i].effectifs[index].effectif }} /
                            {{ selectedNeedsTable.gardeNeeds[i].needs[index].need }}
                          </span>
                          <span
                            class="font-weight-700 font-size-14px margin-left-6px"
                            [class.green-text]="selectedNeedsTable.gardeNeeds[i].diffs[index].diff >= 0"
                            [class.red-text]="selectedNeedsTable.gardeNeeds[i].diffs[index].diff < 0"
                          >
                            ({{
                              (selectedNeedsTable.gardeNeeds[i].diffs[index].diff >= 0 ? '+' : '') +
                                selectedNeedsTable.gardeNeeds[i].diffs[index].diff
                            }})
                          </span>
                        </div>
                      </div>
                    </ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="spinner-wrapper" fxLayout="row" fxLayoutAlign="center center" *ngIf="isDataLoading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
} @else {
  <div class="pd-b-70" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
    <div class="date-header" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="date-picker-container" fxLayout="row" fxLayoutAlign="start center">
        <app-toggle-switch
          *ngIf="isNight !== undefined && showDayNight"
          [isDayNight]="true"
          class="margin-right"
          style="height: fit-content; margin-right: 12px"
          [options]="dayNightOptions"
          [actifOption]="isNight"
          (onOptionClick)="toggleNight()"
        ></app-toggle-switch>
        <app-custom-date-picker-week
          class="with-arrows"
          (dateSwitch)="onWeekChange($event)"
          (weekPicked)="chosenDayHandler($event)"
          [day]="$any(day)"
        ></app-custom-date-picker-week>
        <div class="default-select" *ngIf="gardeNeedsTables && gardeNeedsTables.length > 6">
          <div class="select-container">
            <select
              [(ngModel)]="selectedNeedsTable"
              (ngModelChange)="onChangeSelectedNeedsTable($event)"
              [ngModelOptions]="{ standalone: true }"
            >
              <option *ngFor="let gardeNeedsTable of gardeNeedsTables" [ngValue]="gardeNeedsTable">
                {{ gardeNeedsTable.formationsGroup.displayName }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="message">{{ lastUpdateMessage }}</div>
    </div>

    <div class="tab" *ngIf="gardeNeedsTables && gardeNeedsTables.length <= 6">
      <div
        *ngFor="let gardeNeedsTable of gardeNeedsTables"
        class="tab"
        [class.selected]="
          selectedNeedsTable &&
          selectedNeedsTable.formationsGroup &&
          selectedNeedsTable.formationsGroup.displayName === gardeNeedsTable.formationsGroup.displayName
        "
        (click)="onChangeSelectedNeedsTable(gardeNeedsTable)"
      >
        {{ gardeNeedsTable.formationsGroup.displayName }}
      </div>
    </div>

    <div *ngIf="!isDataLoading">
      <ng-container *ngIf="selectedNeedsTable && (selectedNeedsTable.reasonMapsGarde?.length ?? 0) > 0">
        <div style="margin-bottom: 16px">
          <div class="consultations-container2" fxLayout="column" fxLayoutAlign="start start">
            <table class="width-100">
              <thead>
                <tr>
                  <th class="tab-header-container">
                    <div class="tab-header">
                      <span class="code-rh-title">Codes RH</span>
                      <div class="diagonal-line"></div>
                      <span class="needs-title">Bilan</span>
                    </div>
                  </th>
                  <th *ngFor="let day of days; let i = index">
                    <div class="day-cell-header">
                      <p class="name-day">{{ day }}&nbsp;</p>
                      <p class="date-display-row text-style-1">{{ weekDays[i] }}&nbsp;</p>
                      <p class="day-needs">{{ dayNeeds[i] }}</p>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let reasonMapGarde of selectedNeedsTable.reasonMapsGarde; let index = index">
                  <td>
                    <div style="color: white">{{ reasonMapGarde.code }}</div>
                  </td>
                  <td *ngFor="let day of days; let i = index">
                    <ng-container
                      *ngIf="selectedNeedsTable.gardeNeeds[i] && selectedNeedsTable.gardeNeeds[i].needs.length > 0"
                    >
                      <div
                        fxLayout="row"
                        class="reasonMap-info-container"
                        [ngClass]="{ disabled: isDayDisabled(day, reasonMapGarde) }"
                      >
                        <input
                          [ngClass]="{
                            'c-pointer': accessOption?.permissionWrite,
                            'green-background':
                              selectedNeedsTable.gardeNeeds[i].needs[index].need > 0 &&
                              selectedNeedsTable.gardeNeeds[i].diffs[index].diff >= 0,
                            'red-background': selectedNeedsTable.gardeNeeds[i].diffs[index].diff < 0,
                          }"
                          (keydown)="
                            blockInvalidInput($event, selectedNeedsTable.gardeNeeds[i].needs[index].need, index)
                          "
                          (ngModelChange)="updateDiff($event, index, i)"
                          [disabled]="!accessOption?.permissionWrite"
                          [(ngModel)]="selectedNeedsTable.gardeNeeds[i].needs[index].need"
                          (ngModelChange)="validateNeed($event, i, index, index)"
                          type="number"
                          [min]="0"
                          [max]="999"
                          [maxlength]="3"
                          placeholder="0"
                          (blur)="setDefaultIfEmpty(selectedNeedsTable.gardeNeeds[i].needs[index].need, index, i)"
                          (paste)="preventPaste($event)"
                          (keydown.control.v)="preventPaste($event)"
                          (keydown.meta.v)="preventPaste($event)"
                        />
                        <div *ngIf="accessOption?.permissionWrite" class="select-arrows" fxLayout="column">
                          <button
                            class="custom-icon-button"
                            [disabled]="selectedNeedsTable.gardeNeeds[i].needs[index].need >= 999"
                            mat-icon-button
                            (click)="
                              selectedNeedsTable.gardeNeeds[i].needs[index].need = increaseNeeds(
                                i,
                                index,
                                selectedNeedsTable.gardeNeeds
                              )
                            "
                          >
                            <mat-icon>keyboard_arrow_up</mat-icon>
                          </button>
                          <div class="tick"></div>
                          <button
                            class="custom-icon-button"
                            mat-icon-button
                            [disabled]="selectedNeedsTable.gardeNeeds[i].needs[index].need === 0"
                            matSuffix
                            (click)="
                              selectedNeedsTable.gardeNeeds[i].needs[index].need = decreaseNeeds(
                                i,
                                index,
                                selectedNeedsTable.gardeNeeds
                              )
                            "
                          >
                            <mat-icon>keyboard_arrow_down</mat-icon>
                          </button>
                        </div>
                        <div fxFlexAlign="center">
                          <span
                            class="font-weight-700 font-size-14px"
                            [class.green-text]="selectedNeedsTable.gardeNeeds[i].diffs[index].diff >= 0"
                            [class.red-text]="selectedNeedsTable.gardeNeeds[i].diffs[index].diff < 0"
                          >
                            {{
                              (selectedNeedsTable.gardeNeeds[i].diffs[index].diff >= 0 ? '+' : '') +
                                selectedNeedsTable.gardeNeeds[i].diffs[index].diff
                            }}
                          </span>
                        </div>
                      </div>
                    </ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="spinner-wrapper" fxLayout="row" fxLayoutAlign="center center" *ngIf="isDataLoading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}
